import React, { createContext, useState, useContext } from 'react';
import { Snackbar, Alert } from '@mui/material';

// Create context
const NotificationContext = createContext();

// Singleton object to access the notification function globally
let notificationHandler = null;

export const useNotification = () => useContext(NotificationContext);

// Provider component to wrap the app
export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  // Function to show notification
  const showNotification = (message, severity, duration=3000) => {
    setNotifications((prev) => [...prev, { id: Date.now(), message, severity, duration }]);
  };

  // Expose the notification function globally via the singleton object
  notificationHandler = showNotification;

  // Function to close notification
  const closeNotification = (id) => {
    setNotifications((prev) => prev.filter((notification) => notification.id !== id));
  };

  return (
    <NotificationContext.Provider value={showNotification}>
      {children}
      {notifications.map((notification, index) => (
        <Snackbar
          key={notification.id}
          open
          sx={{
            marginBottom: `${index * 60}px` // Adjust the spacing as needed to show all snackbar in line
          }}
          autoHideDuration={notification.duration}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          onClose={() => closeNotification(notification.id)}>
          <Alert
            onClose={() => closeNotification(notification.id)}
            severity={notification.severity}
            variant="filled"
            sx={{ width: '100%' }}>
            {notification.message}
          </Alert>
        </Snackbar>
      ))}
    </NotificationContext.Provider>
  );
};

// Export a function to trigger notifications globally
export const triggerNotification = (message, severity, duration=3000) => {
  if (notificationHandler) {
    notificationHandler(message, severity, duration);
  } else {
    console.error('Notification system is not initialized');
  }
};
